/**
 * date-time.module
 */
import { A11yModule } from '@angular/cdk/a11y';
import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { OwlCalendarBodyComponent } from '@shared/component/date-time-picker/date-time/calendar-body.component';
import { OwlMonthViewComponent } from '@shared/component/date-time-picker/date-time/calendar-month-view.component';
import { OwlMultiYearViewComponent } from '@shared/component/date-time-picker/date-time/calendar-multi-year-view.component';
import { OwlYearViewComponent } from '@shared/component/date-time-picker/date-time/calendar-year-view.component';
import { OwlCalendarComponent } from '@shared/component/date-time-picker/date-time/calendar.component';
import { OwlDateTimeInlineComponent } from '@shared/component/date-time-picker/date-time/date-time-inline.component';
import { OwlDateTimeContainerComponent } from '@shared/component/date-time-picker/date-time/date-time-picker-container.component';
import { OwlDateTimeInputDirective } from '@shared/component/date-time-picker/date-time/date-time-picker-input.directive';
import { OwlDateTimeIntl } from '@shared/component/date-time-picker/date-time/date-time-picker-intl.service';
import { OwlDateTimeTriggerDirective } from '@shared/component/date-time-picker/date-time/date-time-picker-trigger.directive';
import { OWL_DTPICKER_SCROLL_STRATEGY_PROVIDER, OwlDateTimeComponent } from '@shared/component/date-time-picker/date-time/date-time-picker.component';
import { NumberFixedLenPipe } from '@shared/component/date-time-picker/date-time/numberedFixLen.pipe';
import { OwlTimerBoxComponent } from '@shared/component/date-time-picker/date-time/timer-box.component';
import { OwlTimerComponent } from '@shared/component/date-time-picker/date-time/timer.component';
import { OwlDialogModule } from '@shared/component/date-time-picker/dialog/dialog.module';

@NgModule({
    imports: [CommonModule, OverlayModule, OwlDialogModule, A11yModule],
    exports: [
        OwlCalendarComponent,
        OwlTimerComponent,
        OwlDateTimeTriggerDirective,
        OwlDateTimeInputDirective,
        OwlDateTimeComponent,
        OwlDateTimeInlineComponent,
        OwlMultiYearViewComponent,
        OwlYearViewComponent,
        OwlMonthViewComponent,
    ],
    declarations: [
        OwlDateTimeTriggerDirective,
        OwlDateTimeInputDirective,
        OwlDateTimeComponent,
        OwlDateTimeContainerComponent,
        OwlMultiYearViewComponent,
        OwlYearViewComponent,
        OwlMonthViewComponent,
        OwlTimerComponent,
        OwlTimerBoxComponent,
        OwlCalendarComponent,
        OwlCalendarBodyComponent,
        NumberFixedLenPipe,
        OwlDateTimeInlineComponent,
    ],
    providers: [
        OwlDateTimeIntl,
        OWL_DTPICKER_SCROLL_STRATEGY_PROVIDER,
    ],
    entryComponents: [
        OwlDateTimeContainerComponent,
    ]
})
export class OwlDateTimeModule {
}
